"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonWithIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ButtonWithIcon = require("./ButtonWithIcon.styles");

var _Icon = require("../icon/Icon");

var _shared = require("../../shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ButtonWithIcon = ({
  text,
  icon,
  iconPosition,
  isRoundIcon,
  iconSize,
  ...rest
}) => {
  const Icon = _Icon.Icons[icon];

  if (isRoundIcon) {
    let size = icon && Icon && (Icon === 'Add' || Icon === 'Close') ? 14 : 16;
    return /*#__PURE__*/_react.default.createElement(_ButtonWithIcon.StyledIconButton, _extends({}, rest, {
      isRoundIcon: isRoundIcon
    }), Icon && /*#__PURE__*/_react.default.createElement(Icon, {
      className: "icon",
      size: iconSize ? iconSize : size
    }));
  }

  return /*#__PURE__*/_react.default.createElement(_ButtonWithIcon.StyledIconButton, rest, iconPosition && iconPosition === 'left' && Icon && /*#__PURE__*/_react.default.createElement(Icon, {
    className: "icon left-icon",
    size: iconSize
  }), text, iconPosition && iconPosition === 'right' && Icon && /*#__PURE__*/_react.default.createElement(Icon, {
    className: "icon right-icon",
    size: iconSize
  }));
};

exports.ButtonWithIcon = ButtonWithIcon;
ButtonWithIcon.defaultProps = {
  disabled: false,
  isPrimary: true,
  theme: 'none',
  emphasis: 'none',
  isRoundIcon: false,
  isActive: false,
  buttonSize: '40px',
  iconSize: 16,
  primaryIconColor: _shared.theme.palette.brand.primary.white,
  secondaryIconColor: _shared.theme.palette.brand.primary.charcoal
};
ButtonWithIcon.propTypes = {
  /** Button Text*/
  text: _propTypes.default.string,

  /** Function Callback*/
  onClick: _propTypes.default.func.isRequired,

  /** By Default isPrimary=true*/
  isPrimary: _propTypes.default.bool,

  /** By Default isisRoundIcon=true, default is false*/
  isRoundIcon: _propTypes.default.bool,

  /** Theme 'none',  'light'  & 'dark', default is 'none' */
  theme: _propTypes.default.oneOf(['none', 'dark', 'light']),

  /** Emphasis 'none',  'light'  & 'dark', default is 'none', it will apply for only for secondary button */
  emphasis: _propTypes.default.oneOf(['none', 'high', 'low']),

  /** Icon 'Add, Edit, Close, DownArrow', default null*/
  icon: _propTypes.default.string,

  /** Icon position 'left' and 'right', default undefined */
  iconPosition: _propTypes.default.string,

  /** Explicit Active State, only for rounded button with icon`*/
  isActive: _propTypes.default.bool,

  /** Icon Size, 10, 12, 14, 16 , 18 and 24 */
  iconSize: _propTypes.default.number,

  /** Primary Button Icon Color */
  primaryIconColor: _propTypes.default.string,

  /** Secondary button Icon Color */
  secondaryIconColor: _propTypes.default.string,

  /** Button size */
  buttonSize: _propTypes.default.string,

  /** Stroke Color eg: #ff0000. default transparent */
  strokeColor: _propTypes.default.string
};